export const INVENTORY_REVISION_STATUS_LABELS = {
  draft: "Черновик",
  in_progress: "В процессе",
  counted: "Подсчитано",
  submitted: "Отправлено",
  approved: "Утверждено",
  posted: "Опубликовано",
  cancelled: "Отменен",
};

export const INVENTORY_DIFF_REASON_LABELS = {
  loss_theft: "Кража",
  loss_damage: "Ущерб",
  loss_expired: "Истекший срок",
  loss_accounting_error: "Бухгалтерская ошибка",
  surplus_return: "Возврат брак",
  other: "Other",
};

export function inventoryRevisionStatusLabel(status) {
  const key = String(status || "").toLowerCase();
  return INVENTORY_REVISION_STATUS_LABELS[key] || status || "—";
}

export function inventoryDiffReasonLabel(reason) {
  const key = String(reason || "").toLowerCase();
  return INVENTORY_DIFF_REASON_LABELS[key] || reason || "—";
}

export const INVENTORY_DIFF_REASON_OPTIONS = [
  { value: "loss_theft", label: INVENTORY_DIFF_REASON_LABELS.loss_theft },
  { value: "loss_damage", label: INVENTORY_DIFF_REASON_LABELS.loss_damage },
  { value: "loss_expired", label: INVENTORY_DIFF_REASON_LABELS.loss_expired },
  { value: "loss_accounting_error", label: INVENTORY_DIFF_REASON_LABELS.loss_accounting_error },
  { value: "surplus_return", label: INVENTORY_DIFF_REASON_LABELS.surplus_return },
  { value: "other", label: INVENTORY_DIFF_REASON_LABELS.other },
];


